// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"453":"gift","661":"gift-detail","699":"art-trade","720":"heritage","996":"cultural-mall"}[chunkId] || chunkId) + "." + {"453":"4a307692","457":"91af35c5","661":"cbed3250","699":"51e6cf9f","720":"9b4f3fde","996":"bbc6d7c5"}[chunkId] + ".css";
};